/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAlert, getUserAlertsCns } from 'js/actions/userAlertsAction';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { getColumns } from './columns';
import { Box, SpeedDial, SpeedDialAction } from '@mui/material';
import Swal from 'sweetalert2';
import { Add, Settings } from '@mui/icons-material';
import { useIntl } from 'react-intl';

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

export default function AlertSettings() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { groupId, chargeId } = useParams();
  const navigate = useNavigate();
  const { userAlertsCns } = useSelector((state) => state.userAlert);

  const handleEdit = (data) => {
    navigate(`/editUserAlet/${data.id}`, { state: data });
  };

  const handleNew = () => {
    navigate(`/newUserAlert/${groupId}/charge/${chargeId}`);
  };

  const handleDelete = (alert) => {
    Swal.fire({
      title: 'Está seguro que desea eliminar la alerta ?',
      text: 'El borrado es irreversible!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí,eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value == true) {
        dispatch(deleteAlert(alert.id, chargeId, funRef));
      }
    });
  };

  const funRef = () => {
    dispatch(getUserAlertsCns(chargeId));
  };

  const columns = getColumns(handleDelete, handleEdit, intl);

  useEffect(() => {
    dispatch(getUserAlertsCns(chargeId));
  }, []);

  return (
    <DashboardLayout>
      <Box height={500} width="100%" pr={4} mt={4}>
        <DataGrid
          rows={userAlertsCns}
          columns={columns}
          getRowHeight={(row) => row.id}
          rowSelection={false}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5 },
            },
          }}
          slots={{ toolbar: QuickSearchToolbar }}
          sx={{
            pt: 2,
            pb: 2,
            borderRadius: 2,
            boxShadow: 3,
            height: '100%',
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '& .MuiDataGrid-root': { border: 'none' },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid rgba(224, 224, 224, 1)',
              maxHeight: '60px',
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '1px solid rgb(199, 199, 199)',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid rgb(199, 199, 199)',
              maxHeight: '60px',
            },
          }}
        />
      </Box>
      <SpeedDial
        ariaLabel="Configuraciones"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: '#A53693', // Cambia el color de fondo
            '&:hover': {
              backgroundColor: '#6A1A5F',
            },
          },
        }}
        icon={
          <Settings
            sx={{
              width: 40,
              height: 40,
              transform: 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'rotate(180deg)',
                backgroundColor: '#6A1A5F',
              },
            }}
          />
        }
      >
        <SpeedDialAction
          icon={<Add />}
          onClick={() => handleNew()}
          tooltipTitle="Nueva alerta"
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
      </SpeedDial>
    </DashboardLayout>
  );
}
